import { createAsyncThunk } from '@reduxjs/toolkit';
import { LanguageApi } from '../../api/LanguageApi';

//Language Thunks
//Gets paginated language data
export const getLanguages = createAsyncThunk(
  'language/getLanguages',
  async (action: { page: number; limit: number; searchCode?: string }, thunkAPI) => {
    return LanguageApi.getLanguages(action, thunkAPI.dispatch);
  }
);

//To get a language details
export const getLanguageDetails = createAsyncThunk(
  'language/getLanguageDetails',
  async (action: { request: string[] }, thunkAPI) => {
    return LanguageApi.getLanguageDetails(action, thunkAPI.dispatch);
  }
);

//To update a language
export const updateLanguage = createAsyncThunk(
  'language/updateLanguage',
  async (action: { request }, thunkAPI) => {
    return LanguageApi.updateLanguage(action, thunkAPI.dispatch);
  }
);

//To create a language
export const createLanguage = createAsyncThunk(
  'language/createLanguage',
  async (action: { request }, thunkAPI) => {
    return LanguageApi.createLanguage(action, thunkAPI.dispatch);
  }
);

//To delete the language(s)
export const deleteLanguage = createAsyncThunk(
  'language/deleteLanguage',
  async (action: { request }, thunkAPI) => {
    return LanguageApi.deleteLanguage(action, thunkAPI.dispatch);
  }
);

//Language Association Thunks
//To get paginated language association data
export const getLanguageAssociation = createAsyncThunk(
  'language/getLanguageAssociation',
  async (
    action: { page: number; limit: number; searchCode?: string; productId?: string },
    thunkAPI
  ) => {
    action.productId = action.searchCode;
    return LanguageApi.getLanguageAssociation(action, thunkAPI.dispatch);
  }
);

//To update language association data
export const updateLanguageAssociation = createAsyncThunk(
  'language/updateLanguageAssociation',
  async (action: { request }, thunkAPI) => {
    return LanguageApi.updateLanguageAssociation(action, thunkAPI.dispatch);
  }
);

//To delete language association data
export const deleteLanguageAssociation = createAsyncThunk(
  'language/deleteLanguageAssociation',
  async (action: { request }, thunkAPI) => {
    return LanguageApi.deleteLanguageAssociation(action, thunkAPI.dispatch);
  }
);
